import { PRODUCT_ENTITLEMENTS } from '@headline/schemas'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, Link, redirect } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { ApiReferencePage } from '@/components/api-reference/ApiReferencePage'
import { accountQuery, subaccountsQuery } from '@/lib/queries'
import { primarySubaccount } from '@/lib/stream-workspace'
import { workspaceApiReferenceQuery } from '@/lib/workspace-api-queries'

/**
 * The account workspace's API reference (CLI-1050): its own space's (the primary sub-account's) API
 * page's reference, behind the same gate on the server. Not bought means no surface, redirect to Home.
 */
export const Route = createFileRoute('/app/accounts/$accountId_/api_/reference')({
  loader: async ({ context, params }) => {
    const account = await context.queryClient.ensureQueryData(accountQuery(params.accountId))
    if (!account.entitlements.includes(PRODUCT_ENTITLEMENTS.api)) {
      throw redirect({ to: '/app/accounts/$accountId', params: { accountId: params.accountId } })
    }
    const subs = await context.queryClient.ensureQueryData(subaccountsQuery(params.accountId))
    const subaccountId = primarySubaccount(subs.subaccounts).id
    void context.queryClient.prefetchQuery(workspaceApiReferenceQuery(subaccountId))
  },
  component: AccountApiReference,
})

function AccountApiReference() {
  const { accountId } = Route.useParams()
  const { data: subs } = useSuspenseQuery(subaccountsQuery(accountId))
  return (
    <ApiReferencePage
      subaccountId={primarySubaccount(subs.subaccounts).id}
      back={
        <Link
          to="/app/accounts/$accountId/api"
          params={{ accountId }}
          className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="size-4" /> API & MCP
        </Link>
      }
    />
  )
}
